/**
 * 排出事業者
 */
import Vue from "vue";
import * as httpConst from "../../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/emission_locations`;

const master_search_emission_workplace = {
  namespaced: true,
  state: () => {},
  getters: {},
  actions: {
    /**
     * 排出事業場の取得
     * @return {Promise<unknown>}
     */
    index({ commit }, { query, page }) {
      const params = {
        ...query,
        page: page,
        limit: 30,
      };
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then((data) => {
          let content = data.content;
          resolve(content);
        });
      });
    },
  },
  mutations: {},
};

export default master_search_emission_workplace;
